import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, unref as _unref, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { useRouter } from 'vue-router';
import { nextTick, onMounted, ref, watch } from 'vue';
import { DinhMucCoDinhService } from '@/core/services/DinhMucCoDinh.service';
import { IDinhMucCoDinhNewResponseBase } from '@/core/interfaces/ApiResponses';
import { swalErrNotification } from '@/core/helpers/utils';
import { useLoading } from '@/core/hooks/use-loading';
import { usePagination } from '@/core/hooks/use-pagination';
import { usePageHeader } from '@/core/hooks/usePageHeader';
import { DINH_MUC_CO_DINH } from '@/core/constants/permissions';
import { faPrint } from '@fortawesome/free-solid-svg-icons';
import DinhMucCoDinhTable from '@/components/dinh-muc-co-dinh/dinh-muc-co-dinh-table/DinhMucCoDinhTable.vue';
import PageContentBase from '@/layout/_shared/PageContentBase.vue';
import PageHeaderFilters from '@/layout/header/PageHeaderFilters.vue';
import PageHeaderActions from '@/layout/header/PageHeaderActions.vue';
import PageHeaderActionItem from '@/layout/header/PageHeaderActionItem.vue';
import Pagination from '@/components/shared/pagination/Pagination.vue';
import FilterItem from '@/layout/_shared/FilterItem.vue';
import CapSuaChuaSearchInput from '@/components/shared/cap-sua-chua-search-input/CapSuaChuaSearchInput.vue';
import DanhMucToaXeSearchInput from '@/components/shared/danh-muc-toa-xe-search-input/DanhMucToaXeSearchInput.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'List',
  setup(__props) {

document.title = 'Định mức cố định - Đường sắt Hà Nội';

const items = ref<IDinhMucCoDinhNewResponseBase[]>([]);
const { startLoading, endLoading } = useLoading();
const { push, resolve } = useRouter();
const { currentPage, perPage, totalItems } = usePagination();
const selectedCapSuaChuaId = ref<number | null>(null);
const selectedCapSuaChuaLabel = ref('');
const selectedDmToaXeId = ref<number | null>(null);
const selectedDmToaXeLabel = ref('');

usePageHeader({
  title: 'Danh sách định mức cố định',
  breadcrumbs: [{ text: 'Định mức cố định' }],
  addLabel: 'Thêm đ/mức cố định',
  addPermissions: [DINH_MUC_CO_DINH.TAO_MOI],
  onAdd: () => push({ name: 'tao-moi-dinh-muc-co-dinh' }),
});

const handleCapScClear = () => {
  selectedCapSuaChuaId.value = null;
  selectedCapSuaChuaLabel.value = '';
};

const handleCapScSelect = ({ id, ten_cap_sc }: { id: number; ten_cap_sc: string }) => {
  selectedCapSuaChuaId.value = id;
  selectedCapSuaChuaLabel.value = ten_cap_sc;
};

const handleDmClear = () => {
  selectedDmToaXeId.value = null;
  selectedDmToaXeLabel.value = '';
};

const handleDmSelect = ({ id, ten_danh_muc }: { id: number; ten_danh_muc: string }) => {
  selectedDmToaXeId.value = id;
  selectedDmToaXeLabel.value = ten_danh_muc;
};

const openPrintViewer = () => {
  const route = resolve({
    name: 'xem-danh-sach-dinh-muc-co-dinh',
    query: {
      ...(selectedCapSuaChuaId.value
        ? {
            idCapSc: String(selectedCapSuaChuaId.value),
            tenCapSc: selectedCapSuaChuaLabel.value,
          }
        : {}),
      ...(selectedDmToaXeId.value
        ? {
            idDmToaXe: String(selectedDmToaXeId.value),
            tenDm: selectedDmToaXeLabel.value,
          }
        : {}),
    },
  });

  window.open(route.href, '_blank');
};

watch([() => selectedCapSuaChuaId.value, () => selectedDmToaXeId.value], async () => {
  await nextTick();

  if (currentPage.value === 1) {
    await fetchData();
    return;
  }

  currentPage.value = 1;
});

const fetchData = async () => {
  try {
    await startLoading();

    const {
      data: {
        data: { data, total },
      },
    } = await DinhMucCoDinhService.getList({
      current_page: currentPage.value,
      per_page: perPage.value,
      ...(selectedCapSuaChuaId.value !== null && { id_cap_sc: selectedCapSuaChuaId.value }),
      ...(selectedDmToaXeId.value !== null && { id_dm_toa_xe: selectedDmToaXeId.value }),
    });

    items.value = data;
    totalItems.value = total;
    await endLoading();
  } catch (error) {
    await endLoading();
    await swalErrNotification(error, 'Có lỗi xảy ra');
  }
};

onMounted(async () => {
  await fetchData();
});

watch(
  () => currentPage.value,
  () => {
    fetchData();
  }
);

watch(
  () => perPage.value,
  () => {
    if (currentPage.value === 1) {
      fetchData();
      return;
    }
    currentPage.value = 1;
  }
);

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createBlock(PageContentBase, null, {
    default: _withCtx(() => [
      _createVNode(PageHeaderFilters, null, {
        default: _withCtx(() => [
          _createVNode(FilterItem, { label: "Tìm theo CSC" }, {
            default: _withCtx(() => [
              _createVNode(CapSuaChuaSearchInput, {
                "full-width": "",
                id: selectedCapSuaChuaId.value,
                onClear: handleCapScClear,
                onSelect: handleCapScSelect
              }, null, 8, ["id"])
            ]),
            _: 1
          }),
          _createVNode(FilterItem, { label: "Tìm theo nhóm toa xe" }, {
            default: _withCtx(() => [
              _createVNode(DanhMucToaXeSearchInput, {
                "full-width": "",
                id: selectedDmToaXeId.value,
                "display-label": selectedDmToaXeLabel.value,
                onClear: handleDmClear,
                onSelect: handleDmSelect
              }, null, 8, ["id", "display-label"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(PageHeaderActions, null, {
        default: _withCtx(() => [
          _createVNode(PageHeaderActionItem, { onClick: openPrintViewer }, {
            icon: _withCtx(() => [
              _createVNode(_component_font_awesome_icon, { icon: _unref(faPrint) }, null, 8, ["icon"])
            ]),
            default: _withCtx(() => [
              _createTextVNode(" Xem danh sách định mức cố định (PDF) ")
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(DinhMucCoDinhTable, {
        "cur-page": _unref(currentPage),
        items: items.value,
        "per-page": _unref(perPage),
        "show-so-luong-vat-tu": false
      }, null, 8, ["cur-page", "items", "per-page"]),
      (items.value.length > 0)
        ? (_openBlock(), _createBlock(Pagination, {
            key: 0,
            page: _unref(currentPage),
            "page-size": _unref(perPage),
            total: _unref(totalItems),
            onChangePage: _cache[0] || (_cache[0] = (value) => (currentPage.value = value)),
            onChangePageSize: _cache[1] || (_cache[1] = (value) => (perPage.value = value))
          }, null, 8, ["page", "page-size", "total"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})